import "./config";
import axios from "axios";
var apiUrl = global.platformURI;

// console.log("API URl Path----", apiUrl);

export const authServices = {
  userLogin,
  entrepreneurAdminLogin,
  userSignUp,
  userSignUpUpdate,
  userForgotPassword,
  resetPassword,
  userLoginConfirm,
  userSignInWithCode,
  socialLogin,
  emailExist
};

function userLogin(payload ) {

  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ user: payload }),
    // params:  param
  };
  return fetch(apiUrl + "/api/v1/users/sign_in", requestOptions)
  .then(handleResponse)
  .then(user => {
    return user;
  });
}

function entrepreneurAdminLogin(payload) {
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ user: payload }),
  };
  return fetch(apiUrl + "/api/v1/entrepreneur_admin/login", requestOptions)
  .then(handleResponse)
  .then(user => {
    return user;
  });
}

function userLoginConfirm(payload) {
  const requestOptions = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  };
  return fetch(apiUrl + `/api/v1/users/confirmation?confirmation_token=${payload}`, requestOptions)
  .then(handleResponse)
  .then(user => {
    return user;
  });
}

function userForgotPassword(payload) {
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ user: payload })
  };
  return fetch(apiUrl + "/api/v1/users/password", requestOptions)
  .then(handleResponse)
  .then(user => {
    return user;
  });
}

function userSignUp(payload) {
  const requestOptions = {
    method: 'POST',
    body: payload
  };
  return fetch(apiUrl + "/api/v1/users", requestOptions)
  .then(handleResponse)
  .then(user => {
    return user;
  });
}

function userSignUpUpdate(payload, UUID, token) {
  const requestOptions = {
    method: 'PUT',
    headers: {
      Authorization: `Bearer ${token}`
    },
    body: payload
  };
  return fetch(apiUrl + `/api/v1/users/${sessionStorage.getItem("uuid") || UUID}`, requestOptions)
  .then(handleResponse)
  .then(user => {
    return user;
  });
}

function userSignInWithCode(payload) {
  // console.log(payload, "this is payload");
  return axios.get(apiUrl + `/api/v1/register_codes/match_code?code=${payload}`).then(response => {  return response })
}

function resetPassword(payload, token) {
  const requestOptions = {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ user: payload })
  };
  return fetch(apiUrl + `/api/v1/users/password`, requestOptions)
  .then(handleResponse)
  .then(user => {
    return user;
  });
}

function handleResponse(response) {
  return response.text().then(text => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      if (response.status === 401) {
        // auto logout if 401 response returned from api
        // logout();
      }
      const error = (data) || response.statusText;
      return Promise.reject(error);
    }
    return data;
  });
}

function socialLogin(payload) {
  const requestOptions = {
    method: 'POST',
    body: payload
  };
  return fetch(apiUrl + "/api/v1/social_login", requestOptions)
  .then(handleResponse)
  .then(user => {
    return user;
  });
}

function emailExist(payload) {
  return fetch(apiUrl + `/api/v1/users/verify_email?email=${payload}`)
  .then(handleResponse)
  .then(user => {
    return user;
  });
}

// GENERATE_OTP — send verification code to user email
export function generateOtp(payload) {
  return {
    type: 'GENERATE_OTP',
    method: 'post',
    data: { user: payload },
    URLEndPoint: 'GENERATE_OTP',
    axiosService: true,
    toaster: {
      loading: true,
    },
  };
}

// VALIDATE_OTP — verify entered code
export function validateOtp(payload) {
  return {
    type: 'VALIDATE_OTP',
    method: 'post',
    data: { user: payload },
    URLEndPoint: 'VALIDATE_OTP',
    axiosService: true,
    toaster: {
      loading: true,
    },
  };
}

// IS_NEW_USER — check if email is a new or existing user
export function isNewUser(payload) {
  return {
    type: 'IS_NEW_USER',
    method: 'post',
    data: { user: payload },
    URLEndPoint: 'IS_NEW_USER',
    axiosService: true,
    toaster: { loading: false },
  };
}

// GENERATE_LOGIN_OTP — send access code OTP (with extra registration fields for new users)
export function generateLoginOtp(payload) {
  return {
    type: 'GENERATE_LOGIN_OTP',
    method: 'post',
    data: { user: payload },
    URLEndPoint: 'GENERATE_LOGIN_OTP',
    axiosService: true,
    toaster: { loading: true },
  };
}

// VALIDATE_LOGIN_OTP — verify the access code submitted in step 2
export function validateLoginOtp(payload) {
  return {
    type: 'VALIDATE_LOGIN_OTP',
    method: 'post',
    data: { user: payload },
    URLEndPoint: 'VALIDATE_LOGIN_OTP',
    axiosService: true,
    toaster: { loading: true },
  };
}

export function verifyAccessCode(payload) {
  return {
    type: 'VERIFY_ACCESS_CODE',
    method: 'post',
    data: payload,
    URLEndPoint: 'VERIFY_ACCESS_CODE',
    axiosService: true,
    toaster: { loading: true },
  };
}

export function generateAccessCode(payload) {
  return {
    type: 'GENERATE_ACCESS_CODE',
    method: 'post',
    data: payload,
    URLEndPoint: 'GENERATE_ACCESS_CODE',
    axiosService: true,
    toaster: { loading: true },
  };
}
